import { createSelector } from '@reduxjs/toolkit';

//📌 Selector for get all floors from current profile.
export const selectFloors = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID],
	(floorsData, orgID) => floorsData[orgID] || []
);

//📌 Selector for get floor by floorID.
export const selectFloorsByFloorID = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID, (_, floorID) => floorID],
	(floorsData, orgID, floorID) => (floorsData[orgID] || []).find((floor) => floor.floorID === floorID) || null
);

//📌 Selector for get all floors by siteID.
export const selectFloorsBySiteID = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID, (_, siteID) => siteID],
	(floorsData, orgID, siteID) => (floorsData[orgID] || []).find((floor) => floor.siteID === siteID) || null
);

//📌 Selector for get all floors by name.
export const selectFloorsByName = createSelector(
	[(state) => state.Floors.data, (state) => state.Auth.selectedProfile.orgID, (_, name) => name],
	(floorsData, orgID, name) =>
		(floorsData[orgID] || []).filter((floor) => floor.name.toLowerCase().includes(name.toLowerCase())) || []
);

//📌 Selector for floor plan alert visibility.
export const selectFloorPlanAlertVisible = createSelector(
	[(state) => state.Floors.floorPlanAlert],
	(floorPlanAlert) => floorPlanAlert.visible
);
